import { request } from './httpClient';

// ACON-60: read-only, account-scoped RMAs sourced from AvSight Core. RMA lines
// are returned inline (as `lines`) on each record, so no separate call is needed
// to render the collapsible line detail.
export function getRmas(params) {
  return request({ method: 'GET', url: '/v1/rmas', params });
}
